import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "br-header" }
const _hoisted_2 = { class: "br-context" }
const _hoisted_3 = { class: "br-shot-row" }
const _hoisted_4 = {
  key: 0,
  class: "br-shot-preview"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "br-shot-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
      "max-width": "560px",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "br-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_icon, {
                color: "white",
                size: "20",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-bug-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Raportează o problemă", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                density: "comfortable",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "white",
                    size: "20"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_v_card_text, { class: "br-body" }, {
              default: _withCtx(() => [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "br-label" }, "Ce s-a întâmplat?", -1)),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.descriere,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.descriere) = $event)),
                  variant: "outlined",
                  rows: "4",
                  density: "comfortable",
                  placeholder: "Descrie pe scurt problema (ce făceai, ce ai văzut)...",
                  "hide-details": ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("b", null, "Pagina:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.ruta), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("b", null, "Versiune:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.versiune), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("b", null, "Erori consolă captate:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.errCount), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("b", null, "Request-uri API eșuate:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.netErrCount), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_switch, {
                    modelValue: _ctx.atasezScreenshot,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.atasezScreenshot) = $event)),
                    color: "#ff2c21",
                    density: "compact",
                    "hide-details": "",
                    label: "Atașează captură de ecran"
                  }, null, 8, ["modelValue"])
                ]),
                (_ctx.atasezScreenshot && _ctx.screenshot)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: _ctx.screenshot,
                        alt: "captură"
                      }, null, 8, _hoisted_5)
                    ]))
                  : (_ctx.atasezScreenshot && _ctx.capturing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Se capturează ecranul..."))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "justify-end br-actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialog = false)),
                  disabled: _ctx.sending
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  color: "#ff2c21",
                  variant: "flat",
                  loading: _ctx.sending,
                  disabled: !_ctx.descriere.trim(),
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("Trimite", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}